<template>
  <Loader v-if="loader" />
  <div class="card">
    <h3>Compensa fatture</h3>
    <div class="search-cliente-toolbar mb-4">
      <div class="search-cliente-bar">
        <span class="p-input-icon-left search-cliente-field">
          <InputText
            v-model="searchCliente"
            placeholder="Cerca per nome, cognome, ragione sociale"
            class="search-cliente-input"
            @keyup.enter="onSearchCliente"
          />
        </span>
        <Button
          :label="loader ? '...' : 'Cerca'"
          :icon="loader ? 'pi pi-spinner pi-spin' : 'pi pi-search'"
          class="p-button-primary search-cliente-submit"
          @click="onSearchCliente"
          :disabled="loader"
        />
      </div>
      <Button
        v-if="searchClienteAttivo"
        label="Azzera filtro"
        icon="pi pi-filter-slash"
        class="p-button-outlined p-button-secondary search-cliente-reset"
        @click="resetSearchCliente"
        :disabled="loader"
      />
    </div>
    <TabView :activeIndex="activeIndexTab" @update:activeIndex="changeData">
      <TabPanel v-for="(tab, tabIndex) in tabs" :key="tab.title" :header="tab.title">
        <Accordion
          v-if="activeIndexTab === tabIndex"
          v-model:activeIndex="accordionActiveIndex"
          lazy
          :key="accordionMountKey"
          @tab-open="onClienteExpand"
        >
          <AccordionTab v-for="cliente in clienti" :key="cliente.id">
            <template #header>
              <div class="flex justify-content-between w-full align-items-center">
                <div class="flex flex-column">
                  <p>{{ cliente.label }}</p>
                  <small v-if="cliente.documentiCaricati">
                    Rappresentante: {{ cliente.rappresentante ?? 'Non presente' }}
                  </small>
                  <small v-if="cliente.documentiCaricati">
                    Agente: {{ cliente.agente ?? 'Non presente' }}
                  </small>
                </div>
                <div class="flex flex-column col-2">
                  <div class="flex align-items-center">
                    <Badge :value="cliente.note_credito_count" class="m-2" size="large" severity="success"/>
                    <p v-if="cliente.documentiCaricati">{{ tab.title }}: € {{ reduceArray(cliente.note_credito) }}</p>
                    <p v-else>{{ tab.title }}: {{ cliente.note_credito_count }}</p>
                  </div>
                  <div class="flex align-items-center">
                    <Badge :value="cliente.fatture_count" class="m-2" size="large" severity="danger"/>
                    <p v-if="cliente.documentiCaricati">Fatture: € {{ reduceArray(cliente.fatture) }}</p>
                    <p v-else>Fatture: {{ cliente.fatture_count }}</p>
                  </div>
                </div>
              </div>
            </template>
            <div v-if="!cliente.documentiCaricati" class="flex justify-content-center align-items-center p-4">
              <i class="pi pi-spin pi-spinner mr-2"></i>
              Caricamento documenti...
            </div>
            <div v-else class="flex justify-content-between">
              <div :class="['col-5', {'col-custom': cliente.note_credito.length > 4}]">
                <h4>Note credito</h4>
                <div v-for="el in cliente.note_credito" :key="el.numero" class="mb-3">
                  <div
                    :class="['card-nc flex align-items-center p-2 card-clickable', getBg(el.disabled), { 'card-dettaglio': el.dettaglioCaricato }]"
                    @click="loadDocumentoDettaglio(cliente, 'note_credito', el)"
                  >
                    <Checkbox
                      v-model="el.selected"
                      :binary="true"
                      @click.stop
                      @change="updateSelected(cliente, 'note_credito', el)"
                      :disabled="el.disabled"
                    />
                    <div class="flex flex-column m-2">
                      <p><strong>{{ el.numero }}</strong> del {{ moment(el.data_emissione).format('DD/MM/Y') }}</p>
                      <p>Importo residuo: € <strong>{{ el.saldo.toFixed(2) }}</strong> della fornitura: <strong>{{ el.code }}</strong></p>
                      <p v-if="el.caricamentoDettaglio"><small>Caricamento dettaglio...</small></p>
                      <p v-else-if="el.dettaglioCaricato && el.pagamento">Pagamento: <strong>{{ el.pagamento }}</strong></p>
                      <p v-else><small>Clicca per vedere il pagamento</small></p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 flex justify-content-center">
                <Button label="Associa" class="mt-5 p-button-success btn-custom" v-if="cliente.selected_fatture.length > 0 && cliente.selected_note_credito.length > 0" @click="associa(cliente)"/>
              </div>
              <div :class="['col-5', {'col-custom': cliente.fatture.length > 4}]">
                <h4>Fatture</h4>
                <div v-for="el in cliente.fatture" :key="el.numero" class="mb-3">
                  <div
                    :class="['card-ft flex align-items-center p-2 card-clickable', getBg(el.disabled), { 'card-dettaglio': el.dettaglioCaricato }]"
                    @click="loadDocumentoDettaglio(cliente, 'fatture', el)"
                  >
                    <Checkbox
                      v-model="el.selected"
                      :binary="true"
                      @click.stop
                      @change="updateSelected(cliente, 'fatture', el)"
                      :disabled="el.disabled"
                    />
                    <div class="flex flex-column m-2">
                      <p><strong>{{ el.numero }}</strong> del {{ moment(el.data_emissione).format('DD/MM/Y') }}</p>
                      <p>Importo residuo: € <strong>{{ el.saldo.toFixed(2) }}</strong> della fornitura: <strong>{{ el.code }}</strong></p>
                      <p v-if="el.caricamentoDettaglio"><small>Caricamento dettaglio...</small></p>
                      <p v-else-if="el.dettaglioCaricato && el.pagamento">Pagamento: <strong>{{ el.pagamento }}</strong></p>
                      <p v-else><small>Clicca per vedere il pagamento</small></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AccordionTab>
        </Accordion>
        <div v-if="pagination.total > 0" class="flex justify-content-center mt-3">
          <Paginator
            :first="(pagination.current_page - 1) * pagination.per_page"
            :rows="pagination.per_page"
            :totalRecords="pagination.total"
            @page="onPageChange"
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
            currentPageReportTemplate="{first} a {last} di {totalRecords} clienti"
          />
        </div>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import Service from '@/services/ask-management/fatture-clienti-service'
import { ref, onMounted, getCurrentInstance } from 'vue';
import Loader from '@/components/Loader.vue'
import moment from 'moment'
import { useToast } from 'primevue/usetoast';
import ServicePratiche from '@/services/ask-pratiche/pratiche-service'


export default {
  emits:['movement-regularized'],
  components: {
    Loader,
  },
  setup() {
    const toast = useToast();
    const loader = ref(false)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    self.$http = self.appContext.config.globalProperties.$http
    const service = new Service(self.$http, self.$eventBus)
    const servicePratiche = new ServicePratiche(self.$http, self.$eventBus)
    const clienti = ref([])
    const pagination = ref({
      current_page: 1,
      per_page: 8,
      total: 0,
      last_page: 1,
    })
    const tabs = ref([
      { title: 'Note credito', content: 'note', type_compensazione: 'NOTA CREDITO'},
      { title: 'Credito extra', content: 'extra', type_compensazione: 'SPOSTAMENTO CREDITO DA FATTURA' },
    ]);
    const activeIndexTab = ref()
    const accordionActiveIndex = ref(null)
    const accordionMountKey = ref(0)
    const searchCliente = ref('')
    const searchClienteAttivo = ref('')

    const resetAccordionState = () => {
      accordionActiveIndex.value = null
      accordionMountKey.value += 1
    }

    const normalizeDocumento = (el, type_obj) => ({
      ...el,
      selected: Boolean(el.selected),
      disabled: type_obj !== 'note_credito',
      saldo: parseFloat(el.saldo),
      dettaglioCaricato: false,
      caricamentoDettaglio: false,
    })

    const normalizeClienteLista = (item) => {
      item.note_credito = []
      item.fatture = []
      item.note_credito_count = item.note_credito_count || 0
      item.fatture_count = item.fatture_count || 0
      item.selected_note_credito = []
      item.selected_fatture = []
      item.documentiCaricati = false
      item.caricamentoDocumenti = false
      return item
    }

    const loadClienteDocumenti = async (cliente) => {
      if (cliente.documentiCaricati || cliente.caricamentoDocumenti) {
        return
      }

      cliente.caricamentoDocumenti = true
      const content = tabs.value[activeIndexTab.value].content

      try {
        const data = await service.getNcFattureDocumentiCliente(content, cliente.id)
        if (!data) {
          return
        }

        cliente.agente = data.agente
        cliente.rappresentante = data.rappresentante
        cliente.note_credito = (data.note_credito || []).map(el => normalizeDocumento(el, 'note_credito'))
        cliente.fatture = (data.fatture || []).map(el => normalizeDocumento(el, 'fatture'))
        cliente.documentiCaricati = true
      } finally {
        cliente.caricamentoDocumenti = false
      }
    }

    const loadDocumentoDettaglio = async (cliente, tipo, doc) => {
      if (doc.dettaglioCaricato || doc.caricamentoDettaglio) {
        return
      }

      doc.caricamentoDettaglio = true
      const content = tabs.value[activeIndexTab.value].content

      try {
        const dettaglio = await service.getNcFatturaDettaglio(content, doc.numero, tipo)
        if (!dettaglio) {
          return
        }

        doc.pagamento = dettaglio.pagamento
        doc.saldo = parseFloat(dettaglio.saldo)
        doc.dettaglioCaricato = true
      } finally {
        doc.caricamentoDettaglio = false
      }
    }

    const onClienteExpand = async (event) => {
      const cliente = clienti.value[event.index]
      if (cliente) {
        await loadClienteDocumenti(cliente)
      }
    }

    const getData = async (page = pagination.value.current_page) => {
      resetAccordionState()
      loader.value = true
      clienti.value = []
      
      await service.getNcFatture(
        tabs.value[activeIndexTab.value].content,
        page,
        pagination.value.per_page,
        searchClienteAttivo.value || null,
      )
      .then((res)=>{        
        clienti.value = res.items.map(normalizeClienteLista)
        if (res.pagination) {
          pagination.value = {
            ...pagination.value,
            ...res.pagination,
          }
        }
      })
      .finally(()=>{
        loader.value = false
      })
    }

    const updateSelected = (cliente, type_ft, el) => {
      if (cliente[`selected_${type_ft}`].includes(el.numero)) {
        let indexFt = cliente[`selected_${type_ft}`].findIndex(num => num == el.numero)
        cliente[`selected_${type_ft}`].splice(indexFt, 1)
      }else{
        cliente[`selected_${type_ft}`].push(el.numero)
      }

      if (type_ft == 'note_credito' && cliente.selected_note_credito.length != 0){
        cliente.note_credito.forEach(nc => {
          nc.disabled = nc.numero != el.numero
        })
        cliente.fatture.forEach(ft => {
          ft.disabled = ft.saldo < ((-1)*el.saldo)
        })
      } else if (type_ft == 'note_credito' && cliente.selected_note_credito.length == 0) {
        cliente.note_credito.forEach(ft => {
          ft.disabled = false
        })
        cliente.fatture.forEach(ft => {
          ft.disabled = true
        })
        if (cliente.selected_fatture.length != 0) {
          for (let index = 0; index < cliente.selected_fatture.length; index++) {
            cliente.fatture.forEach(ft => {
              ft.selected = false
              ft.disabled = true
            })
            cliente.selected_fatture.splice(index, 1)
          }
        }
      } else if (cliente.selected_note_credito.length == 0) {
        cliente.fatture.forEach(ft => {
          ft.disabled = true
        })
      } else if (type_ft == 'fatture' && cliente.selected_fatture.length != 0){
        cliente.fatture.forEach(ft => {
          ft.disabled = ft.numero != el.numero
        })
      } else if (type_ft == 'fatture' && cliente.selected_fatture.length == 0){
        cliente.fatture.forEach(ft => {
          ft.disabled = false
        })
      }
      ['note_credito', 'fatture'].forEach(type_obj => {
        if (type_ft == 'note_credito' && type_obj == 'fatture') {
          cliente[type_obj].sort((a, b) => {
            if (a.code === el.code) {
              return -1;
            }
            if (b.code === el.code) {
              return 1;
            }
            return a.code.localeCompare(b.code);
          });
        }        
        cliente[type_obj].sort((a, b) => a.disabled - b.disabled)
      })
    }

    const getBg = (isDisabled) => {
      return isDisabled ? 'card-disabled' : 'card-active'
    }

    const associa = (cliente) => {
      let selected_nota_credito = cliente.note_credito.find(nc => nc.numero == cliente.selected_note_credito[0])
      if (!cliente.selected_fatture.includes(selected_nota_credito.numero)) {
        const obj = {
          numero: selected_nota_credito.numero,
          type_compensazione: tabs.value[activeIndexTab.value].type_compensazione,
          payments: [],
          is_nota_credito: true
        }
        cliente.selected_fatture.forEach(selected_ft => {
          let selected_fattura = cliente.fatture.find(ft => ft.numero == selected_ft)
          obj.payments.push({
            typeAssociate: 'fattura-vendita',
            numero: selected_fattura.numero,
            saldo_modificato: -1*selected_nota_credito.saldo
          })
        })      
  
        servicePratiche.associateNoteToPayments(obj)
        .then((res)=> {
          if (res) {
            cliente.selected_note_credito.forEach(nc => {
              let index_nc = cliente.note_credito.findIndex(nota => nota.numero == nc)            
              if (index_nc != -1) {
                cliente.note_credito.splice(index_nc,1)
              }
            })
  
            cliente.selected_fatture.forEach(ft => {
              let index_ft = cliente.fatture.findIndex(fatt => fatt.numero == ft)
              if (index_ft != -1) {
                let nuovo_saldo = parseFloat((cliente.fatture[index_ft].saldo + selected_nota_credito.saldo).toFixed(2))
                if (nuovo_saldo == 0.00) {
                  cliente.fatture.splice(index_ft,1)
                } else {
                  cliente.fatture[index_ft].selected = false
                  cliente.fatture[index_ft].saldo = nuovo_saldo
                }
              }
            })

            cliente.note_credito_count = cliente.note_credito.length
            cliente.fatture_count = cliente.fatture.length
  
            if (cliente.note_credito.length == 0 || cliente.fatture.length == 0) {
              let index_cliente = clienti.value.findIndex(client => client.id == cliente.id)
              if (index_cliente != -1) {
                clienti.value.splice(index_cliente,1)
                pagination.value.total = Math.max(0, pagination.value.total - 1)
              }
            }else{
              ['note_credito', 'fatture'].forEach(type_obj => {
                cliente[type_obj].forEach(el => {
                  el.selected = false
                  el.disabled = type_obj != 'note_credito'
                })
                cliente[`selected_${type_obj}`] = []
              })
            }
          }else{
            toast.add({severity: 'warn', detail: 'Credito già allocato', life: 5000})
            Promise.all([getData()])
          }
        })
      } else {
        toast.add({severity: 'warn', detail: 'Non è possibile allocare il credito di una fattura alla stessa fattura', life: 5000})
      }      
    }

    onMounted(() => {
      activeIndexTab.value = 0
      getData()
    })

    const onSearchCliente = () => {
      searchClienteAttivo.value = searchCliente.value.trim()
      pagination.value.current_page = 1
      getData(1)
    }

    const resetSearchCliente = () => {
      searchCliente.value = ''
      searchClienteAttivo.value = ''
      pagination.value.current_page = 1
      getData(1)
    }

    const changeData = (evt) => {
      if (evt != activeIndexTab.value) {
        activeIndexTab.value = evt
        pagination.value.current_page = 1
        getData(1)
      }
    }

    const onPageChange = (event) => {
      pagination.value.current_page = (event.first / event.rows) + 1
      pagination.value.per_page = event.rows
      getData(pagination.value.current_page)
    }

    const reduceArray = (array) => {
      let tot = 0
      array.forEach(el => {
        tot += el.saldo
      })
      return (Math.abs(tot)).toFixed(2).replace('.',',')   
    }

    return {
      moment,
      loader,
      service,
      toast,
      clienti,
      pagination,
      accordionActiveIndex,
      accordionMountKey,
      searchCliente,
      searchClienteAttivo,
      onSearchCliente,
      resetSearchCliente,
      updateSelected,
      getBg,
      associa,
      tabs,
      activeIndexTab,
      changeData,
      onPageChange,
      onClienteExpand,
      loadDocumentoDettaglio,
      getData,
      reduceArray
    }
  }
}
</script>
<style>
.search-cliente-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.search-cliente-bar {
  display: flex;
  align-items: stretch;
  flex: 1;
  min-width: min(100%, 520px);
  max-width: 640px;
  background: #ffffff;
  border: 1px solid #dbe3ef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.search-cliente-bar:focus-within {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.15);
}

.search-cliente-field {
  flex: 1;
  display: block;
}

.search-cliente-field .search-cliente-input {
  width: 100%;
  height: 2.75rem;
  border: none;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding-left: 2.5rem;
  font-size: 0.95rem;
}

.search-cliente-field .search-cliente-input:enabled:focus {
  box-shadow: none;
  border: none;
}

.search-cliente-field > i {
  left: 0.9rem;
  color: #94a3b8;
  font-size: 1rem;
}

.search-cliente-submit {
  height: 2.75rem;
  min-width: 6.5rem;
  border-radius: 0;
  border: none;
  border-left: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.search-cliente-reset {
  height: 2.75rem;
  border-radius: 10px;
  white-space: nowrap;
}

.btn-custom{
  width: max-content !important;
  height: max-content !important;
}
.card-nc{
  border: 0.5px solid rgb(106, 255, 0);
  box-shadow: 3px 8px 7px rgb(106, 255, 0);
  border-radius: 10px;
}
.card-ft{
  border: 0.5px solid rgb(255, 30, 0);
  box-shadow: 3px 8px 7px rgb(255, 30, 0);
  border-radius: 10px;
}
.card-clickable{
  cursor: pointer;
}
.card-dettaglio{
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.08);
}
.btn-filter {
  border-radius: 20px;
  width: 140px;
  height: 75px;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
}

.btn-filter:hover {
  opacity: 1;
}

.btn-filter.selected {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.card-disabled{
  background-color: darkgray;
  color:rgba(0, 0, 0, 0.2)
}

.card-active{
  background-color: white;
  color:rgb(0, 0, 0)
}
.col-custom{
  height: 475px;
  overflow-y: scroll;
}
</style>
